/* Labcharge Review 3 – small replacement for the removed Funnelish scripts. No dependencies. */
(function () {
  'use strict';

  var root = document.documentElement;

  /* 1. Sticky bars that appear after N px of scrolling (data-show-after) */
  var showAfter = [].slice.call(document.querySelectorAll('.sticky_show_after[data-show-after]'));
  var ticking = false;
  function updateSticky() {
    var y = window.pageYOffset || root.scrollTop || 0;
    showAfter.forEach(function (el) {
      var limit = parseFloat(el.getAttribute('data-show-after')) || 0;
      el.classList.toggle('visible', y >= limit);
    });
    ticking = false;
  }
  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(updateSticky); }
  }
  if (showAfter.length) {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateSticky();
  }

  /* 2. Hide the bottom sticky bar while the bundle offers are on screen */
  var bundles = document.getElementById('labcharge-bundles');
  if (bundles && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      root.classList.toggle('lc-bundles-visible', entries[0].isIntersecting);
    }).observe(bundles);
  }

  /* 3. Anything with data-scroll-target scrolls to that element */
  function go(e) {
    var el = e.target.closest('[data-scroll-target]');
    if (!el) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    var target = document.querySelector(el.getAttribute('data-scroll-target'));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  document.addEventListener('click', go);
  document.addEventListener('keydown', go);
})();
